<template>
    <div class="space-y-4">

        <!-- Fil d'Ariane des sous-étapes -->
        <div class="flex items-center gap-2 overflow-x-auto pb-1">
            <div
                v-for="(doc, idx) in activeDocSteps"
                :key="doc"
                class="flex items-center gap-2 shrink-0"
            >
                <button
                    class="px-3 py-1.5 rounded-full text-xs font-semibold transition-colors"
                    :class="currentDocStep === doc
                        ? 'bg-blue-600 text-white'
                        : doneDocSteps.includes(doc)
                            ? 'bg-green-100 text-green-700'
                            : 'bg-gray-100 text-slate-400'"
                    @click="wm.currentDocStep = doc"
                >
                    {{ docLabels[doc] }}
                </button>
                <svg v-if="idx < activeDocSteps.length - 1" class="w-3 h-3 text-slate-300 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 18l6-6-6-6" stroke-linecap="round"/>
                </svg>
            </div>
        </div>

        <!-- Composant de sous-étape actif -->
        <component
            :is="currentDocComponent"
            v-if="currentDocComponent"
        />

        <!-- Aucun document -->
        <div v-else class="flex flex-col items-center py-12 text-slate-400">
            <svg class="w-10 h-10 mb-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/>
            </svg>
            <p class="text-sm">Aucun document à remplir</p>
        </div>
    </div>
</template>

<script>
import CerfaForm               from './docs/CerfaForm.vue';
import ContratEntretienStep    from './docs/ContratEntretienStep.vue';
import PvReceptionStep         from './docs/PvReceptionStep.vue';
import AttestationEntretienStep from './docs/AttestationEntretienStep.vue';

const DOC_COMPONENT_MAP = {
    cerfa       : CerfaForm,
    contrat     : ContratEntretienStep,
    pv_reception: PvReceptionStep,
    attestation : AttestationEntretienStep,
};

export default {
    name: 'StepDocuments',
    inject: ['wm'],

    props: {
        activeDocSteps:  { type: Array,  default: () => [] },
        currentDocStep:  { type: String, default: null },
    },

    data() {
        return {
            docLabels: {
                cerfa       : 'CERFA',
                contrat     : "Contrat d'entretien",
                pv_reception: 'PV de réception',
                attestation : "Attestation d'entretien",
            },
        };
    },

    computed: {
        currentDocComponent() {
            const step = this.wm.currentDocStep;
            return step ? DOC_COMPONENT_MAP[step] : null;
        },

        // Marquer comme "done" les sous-étapes déjà visitées avant la courante
        doneDocSteps() {
            const cur = this.wm.currentDocStep;
            const idx = this.activeDocSteps.indexOf(cur);
            return this.activeDocSteps.slice(0, idx);
        },
    },
};
</script>
